var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"dp-table-cell",style:({
    width: _vm.widthString,
  })},[_c('div',{staticClass:"dp-table-cell__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }